module.exports = __webpack_public_path__ + "img/setUpCards_1.43549fc2.jpg";